import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"left\">\n    <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.073 11.721c-.13.286-.088.635.143.865l5.232 5.21c.285.283.735.27 1.005-.03.27-.3.257-.774-.028-1.058L9.73 12.032l4.675-4.745c.283-.287.291-.76.019-1.058-.14-.153-.326-.229-.512-.229-.178 0-.356.07-.493.21l-5.185 5.26c-.01.01-.013.025-.023.036l-.024.021c-.04.045-.061.099-.089.15-.007.015-.02.028-.026.044z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol